import type { Action } from 'state/actions';
import type { OrderActionType } from 'state/secondaryMarket/shared/actions';
import { addKey, patchKey, removeKey } from 'state/utils/collection';

import type { SecondaryMarketPostEventState, SecondaryMarketPostEventStateMap } from './secondaryMarketPostEvent.model';
import { initialSecondaryMarketPostEventState } from './secondaryMarketPostEvent.model';

export function secondaryMarketPostEventReducer(
  state: SecondaryMarketPostEventStateMap = initialSecondaryMarketPostEventState,
  action: Action,
): SecondaryMarketPostEventStateMap {
  const actionTypes: OrderActionType[] = ['CP_ORDER', 'LIMIT_ORDER', 'LIVE'];
  for (const actionType of actionTypes) {
    switch (action.type) {
      case `SECONDARY_MARKET_AMEND_${actionType}_FETCH_REQUESTED` as const:
        return patchKey(state, action.tabId, () => ({
          reloadOrderStatus: 'loading' as const,
        }));
      case `SECONDARY_MARKET_AMEND_${actionType}_FETCH_FAILED` as const:
        return patchKey(state, action.tabId, () => ({
          reloadOrderStatus: 'failed' as const,
        }));
      case `SECONDARY_MARKET_AMEND_${actionType}_FETCHED` as const:
        return patchKey(state, action.tabId, () => ({
          bcsProductKey: action.data.bcsKey
            ? {
                source: action.data.bcsKey.source!,
                subType: action.data.bcsKey.subType!,
                code: action.data.bcsKey.code!,
              }
            : undefined,
          reloadOrderStatus: 'loaded' as const,
        }));

      case `SECONDARY_MARKET_${actionType}_RELOAD_FORM_FETCH_REQUESTED` as const:
        if (action.workspace === 'secondaryMarketPostEvents') {
          return patchKey(state, action.tabId, () => ({ reloadFormStatus: 'loading' as const }));
        }
        return state;
      case `SECONDARY_MARKET_${actionType}_RELOAD_FORM_FETCH_FAILED` as const:
        if (action.workspace === 'secondaryMarketPostEvents') {
          return patchKey(state, action.tabId, () => ({ reloadFormStatus: 'failed' as const }));
        }
        return state;
      case `SECONDARY_MARKET_${actionType}_RELOAD_FORM_FETCHED` as const:
        if (action.workspace === 'secondaryMarketPostEvents') {
          return patchKey(state, action.tabId, () => ({ reloadFormStatus: 'loaded' as const }));
        }
        return state;
      default:
        continue;
    }
  }
  switch (action.type) {
    case 'SECONDARY_MARKET_POSTEVENT_WORKSPACE_ADD_TAB':
      return addKey(state, action.tabId, {
        tabType: action.tabType,
        orderId: action.orderId,
      } as SecondaryMarketPostEventState);

    case 'SECONDARY_MARKET_POSTEVENT_WORKSPACE_REMOVE_TAB':
      return removeKey(state, action.tabId);
    default:
      return state;
  }
}
